import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";

import { groupItemsByStation } from "../../utils/Helpers";

const empty_line = {
  marginTop: "5mm",
};

const PrintStationItems = ({ station, items, isAwaitingPurchase }) => {
  const cellStyle = { border: "1px solid gray", padding: "0 5px" };
  const headerStyle = { border: "1px solid gray", padding: "0 5px", backgroundColor: "#e8e8e8" };
  const numberCell = { border: "1px solid gray", padding: "0 5px", textAlign: "right" };
  
  // For Awaiting Purchase status (1), show items even without labels
  if (isAwaitingPurchase && items && items.length > 0) {
    return (
      <tbody>
        <tr style={headerStyle}>
          <td colSpan="7" style={headerStyle}>
            <b>{station}</b>
          </td>
        </tr>
        {items.map((item) => (
          <tr key={`print-${item.id}`}>
            <td style={cellStyle}>{item.quantity}</td>
            <td style={cellStyle}>{item.name}</td>
            <td style={cellStyle}>{item.brand ? item.brand.brand_name : "-"}</td>
            <td style={cellStyle}>{item.grade ? item.grade.grade : "N/A"}</td>
            <td style={cellStyle}>{item.presentation ? item.presentation : "Case"}</td>
            <td style={numberCell}>-</td>
            <td style={numberCell}>{item.price}</td>
            <td style={numberCell}>{(item.price * item.quantity).toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    );
  }
  
  // Original logic for items with labels
  const labels_qty = items.reduce((acc, item) => item.labels.reduce((acc_label, label) => acc_label + label.number_inventories, 0) + acc, 0)
  if (items && items.length > 0 && labels_qty > 0) {
    return (
      <tbody>
        <tr style={headerStyle}>
          <td colSpan="7" style={headerStyle}>
            <b>{station}</b>
          </td>
        </tr>
        {items.map((item) => (
          item.labels.map(label => {
            return (
              <tr key={`print-${label.id}`}>
                <td style={cellStyle}>{label.number_inventories}</td>
                <td style={cellStyle}>{item.name}</td>
                <td style={cellStyle}>{item.brand ? item.brand.brand_name : "-"}</td>
                <td style={cellStyle}>{item.grade ? item.grade.grade : "N/A"}</td>
                <td style={cellStyle}>{item.presentation ? item.presentation : "Case"}</td>
                <td style={numberCell}>{label.weight}</td>
                <td style={numberCell}>{label.price}</td>
                <td style={numberCell}>{(label.price * label.weight * label.number_inventories).toFixed(2)}</td>
              </tr>
            );
          })
        ))}
      </tbody>
    );
  } else {
    return null;
  }
};

const PrintHeader = ({ poId, vendor, createdBy, date }) => {
  const table = { border: "1px solid gray", width: "100%", borderCollapse: "collapse", textAlign: "center" };
  const tableRow = { border: "1px solid gray" };
  return (
    <div>
      <table style={table}>
        <thead>
          <tr>
            <td style={{ ...tableRow, width: "30%" }}>
              <b>Purchase Order </b>#{poId}
            </td>
            <td style={{ ...tableRow, width: "70%" }} colSpan="2">
              <b>Vendor: </b>
              {vendor}
            </td>
          </tr>
          <tr>
            <td style={{ ...tableRow, width: "30%" }}>
              <b>User: </b>
              {createdBy}
            </td>
            <td style={{ ...tableRow, width: "35%" }}>
              <b>Date: </b>
              {date ? moment(date).format("L") : "-"}
            </td>
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default class PurchaseOrderPrint extends Component {
  render() {
    const { poId, vendor, createdBy, date, items, status } = this.props;
    const itemsByStation = groupItemsByStation(items);
    const cellStyle = { border: "1px solid gray", padding: "5px" };
    const total = status === 1 
      ? _.sumBy(items, function (o) { return o.price * o.quantity })
      : _.sumBy(items, function (o) {
          return o.labels && o.labels.length ? _.sumBy(o.labels, function(label) { return label.price * label.weight * label.number_inventories}) : 0
        });

    return (
      <div className="orderPrint text-center" id={`poPrint${poId}`}>
        <PrintHeader poId={poId} vendor={vendor} createdBy={createdBy} date={date} />
        <div style={empty_line}></div>
        <table style={{ border: "1px solid gray", width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <td style={cellStyle}>
                <b>Inventories</b>
              </td>
              <td style={cellStyle}>
                <b>Item name</b>
              </td>
              <td style={cellStyle}>
                <b>Brand</b>
              </td>
              <td style={cellStyle}>
                <b>Grade</b>
              </td>
              <td style={cellStyle}>
                <b>Presentation</b>
              </td>
              <td style={cellStyle}>
                <b>Quantity</b>
              </td>
              <td style={cellStyle}>
                <b>Unit Price</b>
              </td>
              <td style={cellStyle}>
                <b>Total</b>
              </td>
            </tr>
          </thead>
          {Object.keys(itemsByStation).map((station) => (
            <PrintStationItems station={station} items={itemsByStation[station]} key={station} isAwaitingPurchase={status === 1} />
          ))}
        </table>
        <div style={{ marginTop: "30px" }}>Total: {total.toFixed(2)}</div>
      </div>
    );
  }
}
